export const baseURL = process.env.REACT_APP_API_URL || "http://127.0.0.1:5000";

export const SITE_NAME = "UFC Alpha";
// REPLACE BEFORE LAUNCH with the real Patreon or Discord invite. example.com is a
// reserved, inert domain; /join is the only page that links out to this URL.
export const MEMBERSHIP_URL = "https://discord.gg/fUwuQN58X";
export const GITHUB_URL = "https://github.com/UFCAlpha/UFCFightPredictor";
export const RESPONSIBLE_GAMBLING_URL = "https://www.responsiblegambling.org/";
